import {InvFolderType} from '@crema/types/models/invoice';

const folderList: InvFolderType[] = [
  {id: 119, name: 'All', alias: 'all', icon: 'user'},
  {id: 120, name: 'Sent', alias: 'sent', icon: 'sent'},
  {id: 121, name: 'Paid', alias: 'paid', icon: 'paid'},
  {id: 122, name: 'Declined', alias: 'declined', icon: 'declined'},
  {id: 123, name: 'Cancelled', alias: 'cancelled', icon: 'cancelled'},
];
export default folderList;
